/* eslint-disable no-var */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useContext, useReducer, useState } from 'react';
import { fade, useTheme } from '@material-ui/core/styles';
import { Box, CssBaseline } from '@material-ui/core';
import { Route, Routes } from 'react-router-dom';
import { AppDrawer } from '../../components';
import { emplmenu } from '../../constants';
import {
  EventsContext,
  eventsReducer,
  GlobalContext,
  initEventsContext,
  initSalesContext,
  SalesContext,
  salesReducer,
} from '../../contexts';
import { layoutClasses } from '../../themes';
import Options from '../options';
import { GContextTypes } from '../../types';

import { useServices, useWindowDimensions } from '../../hooks';
import PageLayout from './PageLayout';
import { CalendarContext } from '../../contexts/calendar';
import { initCalendar, calendarReducer } from '../../contexts';
import useCompany from '../../hooks/useCompany';
import EmpLanding from './EmpLanding';
import Appointments from '../adds/Appointments';
import { Invoices } from '../adds';
import CalendarEmp from '../calendar/CalendarEmp';
import Notifications from '../adds/Notifications';
import { useSubscription } from '@apollo/client';
import { eventChange, eventStopChange } from '../../graphql/subscription';

const EmplContent = ({ isEmployee }) => {
  const classes = layoutClasses();
  const [menuitem, setMenuitem] = useState(emplmenu[0]);
  const [evenetOpened, setEvenetOpened] = useState(false);
  const [drawerWidth, setDrawerWidth] = useState(80);
  const [open, setOpen] = useState(false);

  const theme = useTheme();
  const { company, editCompany, refreshcompany } = useCompany();
  const { services, addService, editService } = useServices();
  const { isMobile, height, width } = useWindowDimensions();
  const {
    store: { user, calendar, network, tempId, notify, scrollbar },
    dispatch,
    translate: { words, isRTL },
  }: GContextTypes = useContext(GlobalContext);

  const sub = useSubscription(evenetOpened ? eventStopChange : eventChange, {
    fetchPolicy: 'network-only',
    shouldResubscribe: true,
  });

  const logout = () => {
    dispatch({ type: 'logout' });
  };
  const { employeeId } = user;

  const [calendarStore, calendarDispatch] = useReducer(
    calendarReducer,
    initCalendar
  );

  const [eventsStore, eventsDispatch] = useReducer(
    eventsReducer,
    initEventsContext
  );

  const [salesStore, salesDispatch] = useReducer(
    salesReducer,
    initSalesContext
  );

  return (
    <Box
      className={classes.root}
      dir={isRTL ? 'rtl' : undefined}
      display="flex"
      style={{
        flex: 1,
        backgroundColor: fade(theme.palette.info.light, 0.05),
      }}
    >
      <CssBaseline />
      <AppDrawer
        isRTL={isRTL}
        setMenuitem={setMenuitem}
        menuitem={menuitem}
        user={user}
        menu={emplmenu}
        logout={logout}
        network={network}
        scrollbar={scrollbar}
        drawerWidth={drawerWidth}
        setDrawerWidth={setDrawerWidth}
        open={open}
        setOpen={setOpen}
        isEmployee={isEmployee}
      ></AppDrawer>
      <main className={classes.content}>
        <Routes>
          <Route
            path="/"
            element={
              <EmpLanding
                menuitem={menuitem}
                isRTL={isRTL}
                words={words}
                theme={theme}
                calendar={calendar}
                company={company}
                services={services}
                addService={addService}
                editService={editService}
                user={user}
                employeeId={employeeId}
                sub={sub}
              ></EmpLanding>
            }
          />
          <Route
            path="/mobcalendar"
            element={
              <Box
                style={{
                  marginRight: isMobile ? undefined : 25,
                  marginLeft: isMobile ? undefined : 25,
                  width: isMobile ? undefined : width - drawerWidth - 50,
                  height: height - 50,
                }}
              >
                <CalendarContext.Provider
                  value={{ state: calendarStore, dispatch: calendarDispatch }}
                >
                  <CalendarEmp
                    menuitem={menuitem}
                    isMobile={isMobile}
                    isRTL={isRTL}
                    words={words}
                    theme={theme}
                    calendar={calendar}
                    gDispatch={dispatch}
                    company={company}
                    tempId={tempId}
                    user={user}
                    isEmployee={isEmployee}
                    employeeId={employeeId}
                    evenetOpened={evenetOpened}
                    setEvenetOpened={setEvenetOpened}
                    sub={sub}
                    drawerWidth={drawerWidth}
                  ></CalendarEmp>
                </CalendarContext.Provider>
              </Box>
            }
          />

          <Route
            path="/appointments"
            element={
              <EventsContext.Provider
                value={{ state: eventsStore, dispatch: eventsDispatch }}
              >
                <Appointments
                  menuitem={menuitem}
                  isRTL={isRTL}
                  words={words}
                  theme={theme}
                  company={company}
                  tempId={tempId}
                  isEmployee={isEmployee}
                  employeeId={employeeId}
                ></Appointments>
              </EventsContext.Provider>
            }
          />
          {
            <Route
              path="/invoices"
              element={
                <SalesContext.Provider
                  value={{ state: salesStore, dispatch: salesDispatch }}
                >
                  <Invoices
                    menuitem={menuitem}
                    isRTL={isRTL}
                    words={words}
                    theme={theme}
                    company={company}
                    isEmployee={isEmployee}
                    employeeId={employeeId}
                  ></Invoices>
                </SalesContext.Provider>
              }
            />
          }
          <Route
            path="/notifications"
            element={
              <Notifications
                isRTL={isRTL}
                words={words}
                theme={theme}
                menuitem={menuitem}
                notify={notify}
                dispatch={dispatch}
                company={company}
                user={user}
                isEmployee={isEmployee}
                employeeId={employeeId}
              ></Notifications>
            }
          />

          <Route
            path="/options"
            element={
              <PageLayout
                menuitem={menuitem}
                isRTL={isRTL}
                words={words}
                theme={theme}
                refresh={refreshcompany}
                editCompany={editCompany}
                company={company}
              >
                <Options isEmployee={true}></Options>
              </PageLayout>
            }
          />
        </Routes>
      </main>
    </Box>
  );
};
export default EmplContent;
